













import { Component, Vue } from "vue-property-decorator";
import SidebarOverlay from "./components/sidebar-overlay/SidebarOverlay.vue";
import Content from "./components/content/Content.vue";

import Loading from "@/components/loading/Loading.vue";
import ConfirmationModal from "@/components/confirmationModal/ConfirmationModal.vue";
import LogoutConfirmation from "./components/logout-confirmation/LogoutConfirmation.vue";
import AgroNotificationList from "@/components/agroNotificationList/AgroNotificationList.vue";
import { AUTH_LOGOUT } from "@/store/auth/mutation-types";
import * as ownerService from "@/services/owner";

@Component({
  name: "Main",
  components: {
    AContent: Content,
    SidebarOverlay,
    Loading,
    LogoutConfirmation,
    AgroNotificationList,
    ConfirmationModal
  }
})
export default class Main extends Vue {
  private isLoading: boolean = false;
  private isLoggingOut: boolean = false;

  private showLogoutConfirmation() {
    this.isLoggingOut = true;
  }

  private confirmLogout() {
    this.$store.dispatch(`auth/${AUTH_LOGOUT}`);
    ownerService.clearFilter();
  }

  get userName() {
    return this.$store.state.user.name;
  }
}
